import { Theme, useTheme } from "@fyendalscollection/marketing/lib/ThemeContext";

export interface ThemedImageProps {
	className?: string;
	srcLight: string;
	srcDark: string;
}

export const ThemedImage = ({ className, srcLight, srcDark }: ThemedImageProps): JSX.Element => {
	const theme = useTheme();

	return (
		<img className={className} src={theme === Theme.Light ? srcLight : srcDark} />
	);
};
